import React from 'react';

export const FreelanceNetworkIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <g filter="url(#filter0_d_1685_158)">
            <path
                d="M45 41C45 42.1046 44.1046 43 43 43L5 43C3.89543 43 3 42.1046 3 41L3 6C3 4.89543 3.89543 4 5 4L14.4384 4C15.0785 4 15.68 4.30645 16.0563 4.82434L17.8415 7.28106C18.2178 7.79895 18.8193 8.1054 19.4594 8.1054L43 8.1054C44.1046 8.1054 45 9.00084 45 10.1054L45 41Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 29L6 29L6.00001 11H23L23 29ZM14.6861 24.9502C14.9032 24.8283 20 21.8766 20 18.2299C19.9991 17.3736 19.678 16.5526 19.1072 15.9471C18.5365 15.3416 17.7626 15.0009 16.9554 15C15.9413 15 15.0534 15.5817 14.5 16.3636C13.9466 15.5817 13.0587 15 12.0446 15C11.2374 15.0009 10.4635 15.3416 9.89276 15.9471C9.32198 16.5526 9.00091 17.3736 9 18.2299C9 21.8766 14.0968 24.8283 14.3139 24.9502C14.3711 24.9829 14.435 25 14.5 25C14.565 25 14.6289 24.9829 14.6861 24.9502Z"
                fill="url(#paint0_linear_1685_158)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 42.5L43 42.5C43.8284 42.5 44.5 41.8284 44.5 41L44.5 10.1054C44.5 9.27698 43.8284 8.6054 43 8.6054L19.4594 8.6054C18.6592 8.6054 17.9074 8.22234 17.437 7.57498L15.6518 5.11825C15.3696 4.72984 14.9185 4.5 14.4384 4.5L5 4.5C4.17158 4.5 3.5 5.17157 3.5 6L3.5 41C3.5 41.8284 4.17157 42.5 5 42.5ZM43 43C44.1046 43 45 42.1046 45 41L45 10.1054C45 9.00084 44.1046 8.1054 43 8.1054L19.4594 8.1054C18.8193 8.1054 18.2178 7.79895 17.8415 7.28106L16.0563 4.82434C15.68 4.30645 15.0785 4 14.4384 4L5 4C3.89543 4 3 4.89543 3 6L3 41C3 42.1046 3.89543 43 5 43L43 43Z"
                fill="#E4E5E7"
            />
            <path d="M42 11V29H26L26 11L42 11Z" fill="#C5C6C9" />
            <path d="M26 40L42 40V32L26 32V40Z" fill="#E8F094" />
            <path d="M6 32H23V33.2632H6V32Z" fill="#C5C6C9" />
            <path d="M6 35.3684H23V36.6316H6V35.3684Z" fill="#C5C6C9" />
            <path d="M23 38.7368H6V40H23V38.7368Z" fill="#C5C6C9" />
            <path
                d="M28 6C28 4.89543 28.8954 4 30 4H38C39.1046 4 40 4.89543 40 6V14C40 15.1046 39.1046 16 38 16H30C28.8954 16 28 15.1046 28 14V6Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38 4.5H30C29.1716 4.5 28.5 5.17157 28.5 6V14C28.5 14.8284 29.1716 15.5 30 15.5H38C38.8284 15.5 39.5 14.8284 39.5 14V6C39.5 5.17157 38.8284 4.5 38 4.5ZM30 4C28.8954 4 28 4.89543 28 6V14C28 15.1046 28.8954 16 30 16H38C39.1046 16 40 15.1046 40 14V6C40 4.89543 39.1046 4 38 4H30Z"
                fill="#E4E5E7"
            />
            <path
                d="M34.6371 9.41478H37V10.5852H34.6371V13H33.3753V10.5852H31V9.41478H33.3753V7H34.6371V9.41478Z"
                fill="#222325"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1685_158"
                x="0"
                y="1"
                width="48"
                height="45"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1.5" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1685_158" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1685_158" result="shape" />
            </filter>
            <linearGradient
                id="paint0_linear_1685_158"
                x1="15.2083"
                y1="31.2979"
                x2="11.0775"
                y2="-10.034"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#005C25" />
                <stop offset="1" stopColor="#BBCE00" />
            </linearGradient>
        </defs>
    </svg>
);
